module.exports = __webpack_public_path__ + "static/media/result.e3dd951.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/result.mp4
// module id = sp0J
// module chunks = 0